function ajax (url, callback)
{
   var request = new XMLHttpRequest();
   request.onreadystatechange = function()
   {
       if (request.readyState == 4 && request.status == 200)
       {
           callback(request.responseText); // Another callback here
       }
   };
   request.open('GET', url);
   request.send();
}

module.exports = ajax;



/** WEBPACK FOOTER **
 ** ./~/blended-hostlib-js/Controller/Ajax.js
 **/